module.exports = "../../static/img/card5.66921fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile/card5.png
// module id = Idzx
// module chunks = 1